var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLikes(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1929",
    "data-name": "Group 1929",
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.538,
    height: 29,
    viewBox: "0 0 25.538 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4988",
    "data-name": "Path 4988",
    d: "M450.727,149.971a3.372,3.372,0,0,0-1.037-.157,23.928,23.928,0,0,1-4.475-1.155c-.132-.045-.161-.117-.161-.246q0-6.2,0-12.4c0-.19.1-.239.227-.3a10.126,10.126,0,0,0,2.43-1.526,6.182,6.182,0,0,0,1.6-2.653,14.649,14.649,0,0,0,.851-4.537.812.812,0,0,1,.724-.842,3.946,3.946,0,0,1,3.258.945,3.27,3.27,0,0,1,1.107,2.425,15.851,15.851,0,0,1-.608,4.552c-.014.045-.026.091-.043.134-.166.437-.166.437.318.437q2.958,0,5.916,0a3.186,3.186,0,0,1,1.915.565,2.466,2.466,0,0,1,.574,3.413.373.373,0,0,0-.005.54,2.537,2.537,0,0,1-1.174,3.816c-.213.079-.231.154-.172.356a2.522,2.522,0,0,1-1.516,3.038c-.224.083-.242.156-.178.375a2.547,2.547,0,0,1-2.1,3.165c-.051.006-.117-.023-.14.055Z",
    transform: "translate(-438.238 -120.972)",
    fill: "#777e90"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4989",
    "data-name": "Path 4989",
    d: "M380.282,223.264a1.026,1.026,0,0,1-.652-1.092c.011-4.386.006-8.771.008-13.158a1.809,1.809,0,0,1,.043-.476.849.849,0,0,1,.892-.6c1.076-.006,2.15-.008,3.226,0a.86.86,0,0,1,.944.954q0,6.706,0,13.412a.947.947,0,0,1-.671.956Z",
    transform: "translate(-379.63 -194.265)",
    fill: "#777e90"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4990",
    "data-name": "Path 4990",
    d: "M478.664,76.65a.812.812,0,0,1,.707.452c.3.576.595,1.153.869,1.739a.838.838,0,0,1-.395,1.127.827.827,0,0,1-1.113-.368c-.309-.58-.611-1.165-.882-1.764A.849.849,0,0,1,478.664,76.65Z",
    transform: "translate(-467.556 -76.648)",
    fill: "#777e90"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4991",
    "data-name": "Path 4991",
    d: "M537.617,77.514a.829.829,0,0,1-.116.413c-.26.521-.519,1.043-.783,1.562a.854.854,0,1,1-1.526-.751c.272-.557.546-1.113.838-1.66a.822.822,0,0,1,.958-.418A.845.845,0,0,1,537.617,77.514Z",
    transform: "translate(-518.894 -76.63)",
    fill: "#777e90"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4992",
    "data-name": "Path 4992",
    d: "M446.843,127.266c-.293,0-.585.006-.878,0a.829.829,0,0,1-.835-.79.816.816,0,0,1,.757-.893,18.3,18.3,0,0,1,1.867,0,.832.832,0,0,1,.772.886.843.843,0,0,1-.862.8C447.39,127.271,447.116,127.266,446.843,127.266Z",
    transform: "translate(-438.309 -120.462)",
    fill: "#777e90"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4993",
    "data-name": "Path 4993",
    d: "M561.186,127.271c-.274,0-.548.006-.82,0a.844.844,0,0,1-.859-.8.834.834,0,0,1,.777-.883,18.3,18.3,0,0,1,1.867,0,.809.809,0,0,1,.751.9.826.826,0,0,1-.837.786C561.772,127.277,561.479,127.271,561.186,127.271Z",
    transform: "translate(-540.776 -120.466)",
    fill: "#777e90"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikes);
export default __webpack_public_path__ + "static/media/likes.2f6470ca6a0f2845dbcdae07574cde32.svg";
export { ForwardRef as ReactComponent };